import { useAppSelector } from '../index';

export const useAuthSelector = () => useAppSelector((state) => state.auth);

export const useUserAccountSelector = () => useAuthSelector()?.data?.account;
